import { findParentNodeClosestToPos } from "@tiptap/core";

import { isCellSelection } from "@/components/tiptap/utils/isCellSelection";

import type { Selection } from "@tiptap/pm/state";

export function isEveryCellSelected(selection: Selection): boolean {
  if (!isCellSelection(selection)) {
    return false;
  }

  let cellCount = 0;
  const table = findParentNodeClosestToPos(selection.ranges[0].$from, (node) => {
    return node.type.name === "table";
  });

  table?.node.descendants((node) => {
    if (["tableCell", "tableHeader"].includes(node.type.name)) {
      cellCount += 1;
    }
  });

  return cellCount === selection.ranges.length;
}
